var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLightbulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.567 22.564H13.5l-.314.557a1.382 1.382 0 0 1-2.41 0l-.313-.556h-1.07v-.753h5.174v.752Zm0-1.301H9.392v-.792h5.175v.792Zm0-2.168H9.392v.792h5.175v-.792Zm7.142-6.03-2.26-.604.17-.635 2.26.605-.17.635Zm-19.3 0-.169-.634 2.26-.605.169.635-2.26.605Zm17.21-4.61-.17-.635 2.26-.605.17.635-2.26.605Zm-15.12 0L2.24 7.848l.17-.635 2.259.605-.17.637ZM17.763 4.9l-.465-.465 1.654-1.655.466.466L17.763 4.9Zm-11.408 0L4.701 3.247l.466-.466L6.82 4.436l-.466.465Zm8.024-2.15-.635-.17.607-2.26.635.169-.607 2.26Zm-4.64 0L9.133.49l.635-.17.605 2.26-.634.17Zm1.543 9.348h1.396v6.466h-1.396v-6.466Zm.698-8.283c-3.42-.098-6.224 2.742-6.224 6.26 0 1.81.744 3.44 1.931 4.582 1.043 1.003 1.707 2.433 1.707 3.907h1.451v-6.466H9.793c-.823 0-1.49-.669-1.49-1.49 0-.82.669-1.489 1.49-1.489.82 0 1.49.669 1.49 1.49v1.05h1.395v-1.052a1.491 1.491 0 0 1 2.98 0c-.001.82-.67 1.49-1.49 1.49h-1.052v6.465h1.451c0-1.473.664-2.904 1.707-3.907a6.339 6.339 0 0 0 1.931-4.58c-.001-3.518-2.804-6.36-6.225-6.26Zm-2.187 5.74a1.052 1.052 0 0 0 0 2.103h1.05v-1.051c0-.58-.471-1.051-1.05-1.051Zm4.374 2.105h-1.051v-1.053c0-.58.472-1.051 1.051-1.051a1.053 1.053 0 0 1 0 2.104Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.66801618.svg";
export { ForwardRef as ReactComponent };